export function createGameSettings(
    botMovingDelay: number,
    cellCloningDelay: number
) {
    return {
        botMovingDelay,
        cellCloningDelay
    };
}
